export default "__VITE_ASSET__EuxAV8ud__"